import { render, staticRenderFns } from "./knowledge-search.vue?vue&type=template&id=74c577a8"
import script from "./knowledge-search.vue?vue&type=script&lang=js"
export * from "./knowledge-search.vue?vue&type=script&lang=js"
import style0 from "./knowledge-search.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports